'use client'

export type TcfData = {
    eventStatus: string
    listenerId?: number
}

export type TcfCallback = (data: TcfData, success: boolean) => void
export type TcfApi = (command: string, version: number, callback: TcfCallback, parameter?: unknown) => void

type TcfTarget = Pick<Window, '__tcfapi'>

const readinessPromises = new WeakMap<object, Promise<void>>()
const READY_EVENT_STATUSES = new Set(['tcloaded', 'useractioncomplete'])

export function resolveTcfReady(api: TcfApi): Promise<void> {
    return new Promise((resolve) => {
        let resolved = false

        const resolveIfReady: TcfCallback = (data, success) => {
            if (!success || resolved || !READY_EVENT_STATUSES.has(data.eventStatus)) {
                return
            }

            resolved = true
            if (data.listenerId !== undefined) {
                api('removeEventListener', 2, () => undefined, data.listenerId)
            }
            resolve()
        }

        api('addEventListener', 2, resolveIfReady)
    })
}

export function waitForTcfReady(target: TcfTarget = window): Promise<void> {
    const cachedReadiness = readinessPromises.get(target)
    if (cachedReadiness) {
        return cachedReadiness
    }

    const readiness = target.__tcfapi ? resolveTcfReady(target.__tcfapi) : new Promise<void>(() => undefined)
    readinessPromises.set(target, readiness)
    return readiness
}
